import axios from 'axios'
import router from '../router'
import store from '../store'

export default () => {
  axios.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken
    }
    return config
  })
  axios.interceptors.response.use((response) => {
    // Return a successful response back to the calling service
    return response
  }, (error) => {
    // Return any error which is not due to authentication back to the calling service
    if (error.response && error.response.status === 401 && !router.currentRoute.value.fullPath.includes('/login')) {
      localStorage.removeItem('user')
      store.dispatch('auth/logout')
      router.push('/login')
    } else {
      console.error('Axios error:', error)
    }
    return new Promise((resolve, reject) => {
      reject(error)
    })
  })
}
